var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 114,
    height: 114,
    viewBox: "0 0 401 424",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DFDFDF",
    d: "M1 25h399v399H1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    stroke: "#979797",
    d: "M11 25h379c5.523 0 10 4.477 10 10v62h0H1V35c0-5.523 4.477-10 10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#676767",
    strokeWidth: 8,
    d: "M59.5 24.5c0-11.046-8.73-20-19.5-20s-19.5 8.954-19.5 20 8.73 20 19.5 20M108.5 24.5c0-11.046-8.73-20-19.5-20s-19.5 8.954-19.5 20 8.73 20 19.5 20M157.5 24.5c0-11.046-8.73-20-19.5-20s-19.5 8.954-19.5 20 8.73 20 19.5 20M206.5 24.5c0-11.046-8.73-20-19.5-20s-19.5 8.954-19.5 20 8.73 20 19.5 20M255.5 24.5c0-11.046-8.73-20-19.5-20s-19.5 8.954-19.5 20 8.73 20 19.5 20M304.5 24.5c0-11.046-8.73-20-19.5-20s-19.5 8.954-19.5 20 8.73 20 19.5 20M353.5 24.5c0-11.046-8.73-20-19.5-20s-19.5 8.954-19.5 20 8.73 20 19.5 20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M362 25h28c5.523 0 10 4.477 10 10v379c0 5.523-4.477 10-10 10h-28V25z",
    opacity: 0.079
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(104 152)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M84 0C37.608 0 0 37.616 0 84.017v100.884c0 7.32 4.038 14.043 10.5 17.48a22.358 22.358 0 0 0 21 0 22.358 22.358 0 0 1 21 0 22.358 22.358 0 0 0 21 0 22.358 22.358 0 0 1 21 0 22.358 22.358 0 0 0 21 0 22.358 22.358 0 0 1 21 0 22.358 22.358 0 0 0 21 0 19.799 19.799 0 0 0 10.5-17.48V84.017C168 37.616 130.392 0 84 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M140.784 202.385c6.515-3.437 10.586-10.16 10.586-17.48V84.019C151.37 40.4 117.867 4.549 75 .403A86.414 86.414 0 0 1 83.315 0C130.085 0 168 37.617 168 84.019v100.886c0 7.32-4.071 14.043-10.585 17.48a22.7 22.7 0 0 1-18.901 1.035c.77-.304 1.53-.644 2.27-1.035z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 84,
    cy: 98,
    fill: "#5C576E",
    rx: 9,
    ry: 10
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#423E4F",
    d: "M50.104 85.656c-1.714 0-3.103-1.363-3.103-3.044V76.05c0-1.681 1.39-3.044 3.103-3.044 1.714 0 3.104 1.363 3.104 3.044v6.563c0 1.681-1.39 3.044-3.104 3.044zm67.756 0c-1.714 0-3.104-1.363-3.104-3.044V76.05c0-1.681 1.39-3.044 3.104-3.044 1.715 0 3.104 1.363 3.104 3.044v6.563c0 1.681-1.39 3.044-3.104 3.044z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyList);
export default __webpack_public_path__ + "static/media/empty-list.99a933866ad2657c8aecb9524e0cef7b.svg";
export { ForwardRef as ReactComponent };